import axios from 'axios';

const api = axios.create({
  baseURL : 'https://blog.anageimoveis.com.br/wp-json/wp/v2/posts',
  // baseURL : 'https://blog.anageimoveis.com.br/v2/categories',
})

export default api;
